import { Meteor } from 'meteor/meteor';
import { ValidatedMethod } from 'meteor/mdg:validated-method';
import { SimpleSchema } from 'meteor/aldeed:simple-schema';
import { DDPRateLimiter } from 'meteor/ddp-rate-limiter';
import _ from 'lodash';
import moment from 'moment'; 

import { Flights } from '../flights/flights';
import { Montgolfieres } from '../montgolfieres/montgolfieres';

export const montgolfieresFlightsStatistics = new ValidatedMethod({
	name: 'montgolfieres.statistics',
	validate: new SimpleSchema({
		from: { type: String },
		to: { type: String },
		affichage: { type: String }
	}).validator(),
	run({ from, to, affichage }) {
		
		let datas = [];
		let montgolfieres = Montgolfieres.find().fetch();
		
		_.each(montgolfieres, (montgolfiere) => {
			let color = (Math.floor(Math.random() * 256)) + ',' + (Math.floor(Math.random() * 256)) + ',' + (Math.floor(Math.random() * 256));
			
	    	let startOf = affichage.slice(0, -1);
	        let data = [];

	        for(let i = 0; i <= moment(to).diff(moment(from), affichage); i++) {

	            let startDate = moment(from).startOf(startOf).add('1', 'hours').add(i, affichage).toDate();
	            let endDate = moment(from).endOf(startOf).add(i, affichage).toDate();

	            if(i == 0) {
	            	startDate = moment(from).toDate();
	            }

	            if(i == moment(to).diff(moment(from), affichage)) {
	            	let endDate = moment(to).toDate();
	            }
	            
	            data.push(Flights.find({date: {$gte: startDate, $lte: endDate}, status: "validated", montgolfiereId: montgolfiere._id}).fetch().length);
	        }

			datas.push([montgolfiere.name, data, color]);
		});

		return datas;
	}
});

export const montgolfieresHoursStatistics = new ValidatedMethod({
	name: 'montgolfieres.hours.statistics',
	validate: new SimpleSchema({
		from: { type: String },
		to: { type: String },
		affichage: { type: String }
	}).validator(),
	run({ from, to, affichage }) {
		
		let datas = [];
		let montgolfieres = Montgolfieres.find().fetch();
		
		_.each(montgolfieres, (montgolfiere) => {
			let color = (Math.floor(Math.random() * 256)) + ',' + (Math.floor(Math.random() * 256)) + ',' + (Math.floor(Math.random() * 256));
			
	    	let startOf = affichage.slice(0, -1);
	        let data = [];

	        for(let i = 0; i <= moment(to).diff(moment(from), affichage); i++) {

	            let startDate = moment(from).startOf(startOf).add('1', 'hours').add(i, affichage).toDate();
	            let endDate = moment(from).endOf(startOf).add(i, affichage).toDate();

	            if(i == 0) {
	            	startDate = moment(from).toDate();
	            }

	            if(i == moment(to).diff(moment(from), affichage)) {
	            	let endDate = moment(to).toDate();
	            }
	            
	            let hours = 0;
	            _.each(Flights.find({date: {$gte: startDate, $lte: endDate}, status: "validated", montgolfiereId: montgolfiere._id}).fetch(), (flight) => {
	            	hours += flight.time;
	            });

	            hours = Math.round(((hours/60))*10)/10;

	            data.push(hours);
	        }

			datas.push([montgolfiere.name, data, color]);
		});

		return datas;
	}
});


// Get list of all method names on Lists
const LISTS_METHODS = _.map([
	montgolfieresFlightsStatistics,
], 'name');

if (Meteor.isServer) {
  // Only allow 5 list operations per connection per second
  DDPRateLimiter.addRule({
    name(name) {
      return _.includes(LISTS_METHODS, name);
    },

    // Rate limit per connection ID
    connectionId() { return true; },
  }, 5, 1000);
}



/** WEBPACK FOOTER **
 ** ./src/universal/collections/statistics/montgolfieres.js
 **/